<template>
  <div class="container" />
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import browserSignature from 'browser-signature';
const signature = browserSignature();

export default {

  data() {
    return {
      nonce: this.$route.query.nonce ?? '',
    };
  },
  computed: {
    ...mapGetters(["isSSOLogin", "userObject", "user", "userFailedResponse"])
  },

  watch: {
    userObject: function () {
      if (this.userObject != 'undefined') {
        localStorage.setItem('user', JSON.stringify(this.userObject))
        this.setUser()
      }
    },

    user: function () {
      localStorage.setItem('user', JSON.stringify(this.user))
      this.getProfile({})
    },

    userFailedResponse: function () {
      if (this.userObject != 'undefined') {
        const payload = this.$route.query.payload || null
        if (payload) {
          const decoded = JSON.parse(atob(decodeURIComponent(payload))) || null
          if (decoded) {
            window.location = decoded.failure
          }
        }
      }
    },

  },

  mounted() {
    const loginFailed = this.$route.query.login_failed ?? 0

    if (!this.isSSOLogin && loginFailed == '0') {
      this.onSSOLogin()
    } else {
      if (this.userObject != 'undefined') {
        this.setUser()
      }
    }
  },

  methods: {
    ...mapActions(["setSSOLogin", "getProfile"]),
    onSSOLogin() {
      this.setSSOLogin({
        nonce: this.nonce,
        device_type: "web",
        from_device_id: this.$route.query.from_device_id,
        device_id: signature,
        timestamp: (new Date()).getTime()
      });
    },

    setUser() {
      this.setSsoObject()
      let redirect_to = this.$route.query?.redirect_to ?? 'dashboard'
      if (redirect_to == 'dashboard') {
        this.$router.replace({ name: "dashboard" })
      }
      else if (redirect_to == 'protection-plan') {
        this.$router.replace({ name: "plans" })

      }
    },

    setSsoObject() {
      
      const payload = this.$route.query.payload

      if (payload) {
        const decoded = JSON.parse(atob(decodeURIComponent(payload))) || null
        if (decoded) {
          localStorage.removeItem("SSOLogin")
          localStorage.setItem("SSOLogin", JSON.stringify(decoded))
        }
      }
    }
  },
};
</script>
